// extracted by mini-css-extract-plugin
export var logo = "_it-2";
export var logoWrapper = "_it-1";
export var strip = "_it-0";